module.exports = __webpack_public_path__ + "img/phoneView_min.f2774ff4.png";